import React, {Component} from "react";
import logo from "../images/success.jpg";
import Cookies from "universal-cookie";
//import { useLocation } from "react-router-dom";
//import config from "../config";
const cookies =new Cookies() ;
class Success extends Component{
    constructor(props){
        super();
        this.state={message1:"",message2:""};
    }

    componentDidMount(){
       // let location = useLocation();
       this.setState({message1:this.props.location.state.msg1,message2:this.props.location.state.msg2});
    
        if( cookies.get('LoginID'))
        {   
            console.log(cookies.get('LoginID'));
        } // Pacman
    }
    render(){
  //      window.location.href="https://www.thekandnsway.pk/kandns";
        return(
            <div className="auth-wrapper">
            <div className="auth-inner" id="inn" >

            <div className="form-group" >
                <span align="center"><h4>{this.state.message1}</h4></span>
                <h3><img src={logo} alt="Logo" /> </h3>
                <div align="center"><span align="center">{this.state.message2} </span></div>
            </div>
            </div>
    
        </div>
        )
    }
}
export default Success;